import { StarIcon } from "@chakra-ui/icons";
import { Flex, Text, Link, InputGroup, InputRightElement, Image } from "@chakra-ui/react";
import { Button, Input } from "components";
import { ChangeEvent, useState } from "react";
import { useHistory } from "react-router-dom";

type BookDetailsTileProps = {
  url: string;
  image: string;
  type: string;
  title: string;
  rating: number;
  numberOfReviews: number;
  price: number;
  nights: number;
  housekeepingFee: number;
  platformFee: number;
  parkingFee: number;
};

const BookDetailsTile = ({ url, image, type, title, rating, numberOfReviews, nights, price, parkingFee, housekeepingFee, platformFee }: BookDetailsTileProps) => {
  const [promocode, setPromocode] = useState<string>();
  const history = useHistory();

  const onPromocodeChange = (event: ChangeEvent<HTMLSelectElement | HTMLInputElement>) => setPromocode(event.target.value);
  const onApply = () => console.log(promocode);

  return (
    <Flex
      padding={[5, 5, 10]}
      flexDirection='column'
      boxShadow="0px 25px 50px -12px rgba(151, 151, 151, 0.25)"
      borderRadius="50px"
      minW={['auto', 'auto', 450]}
      height={['100%']}
    >
      <Flex
        padding={[5, 8, 10, 5]}
        boxShadow="0px 25px 50px -12px rgba(151, 151, 151, 0.25)"
        borderRadius={[20, 30, 40, 20]}
        flexDirection={['column', 'row', 'row']}
        gap={[5]}
      >
        <Image src={image}
          maxWidth={['auto', 250, 'auto', 180]}
          maxHeight={['auto', 250, 'auto', 180]}
          objectFit='cover' />

        <Flex flexDirection={['column']} justifyContent='space-between'>
          <Flex flexDirection='column'>
            <Text fontFamily='Montserrat' fontWeight={400} fontSize="14px" color='#A3A3A3'>{type}</Text>
            <Text fontFamily='Montserrat' fontWeight={700} fontSize="18px" color='#1F1E1E'>{title}</Text>
          </Flex>
          <Flex gap={[5]} align='center'>
            <StarIcon />
            <Text fontFamily='Montserrat' fontWeight={500} fontSize="10px" color='#1F1E1E'>{rating}</Text>
            <Link fontFamily='Montserrat' fontWeight={500} fontSize="10px" color='#1F1E1E'>{numberOfReviews} reviews</Link>
          </Flex>
        </Flex>
      </Flex>
      <InputGroup marginTop={5} size='md' marginBottom={5}>
        <Input
          variant='filled'
          placeholder='Enter promocode'
          onChange={onPromocodeChange}
        />
        <InputRightElement backgroundColor='white' borderRadius='50px' marginRight={2} width='4.5rem'>
          <Text fontSize="16px" cursor='pointer' fontWeight={500} padding={2} onClick={onApply}> Apply </Text>
        </InputRightElement>
      </InputGroup>
      <Flex justifyContent='space-between' marginBottom={2}>
        <Text fontSize='14px' fontWeight={400} color="#A3A3A3">
          Stay Price ({nights} Nights x €{price})
        </Text>
        <Text fontSize='14px' fontWeight={400} color="#A3A3A3">
          €{price * nights}
        </Text>
      </Flex>
      <Flex justifyContent='space-between' marginBottom={2}>
        <Text fontSize='14px' fontWeight={400} color="#A3A3A3">
          Housekeeping fee
        </Text>
        <Text fontSize='14px' fontWeight={400} color="#A3A3A3">
          €{housekeepingFee}
        </Text>
      </Flex>
      <Flex justifyContent='space-between' marginBottom={2}>
        <Text fontSize='14px' fontWeight={400} color="#A3A3A3">
          Platfrom fee
        </Text>
        <Text fontSize='14px' fontWeight={400} color="#A3A3A3">
          €{platformFee}
        </Text>
      </Flex>
      <Flex justifyContent='space-between' marginBottom={5}>
        <Text fontSize='14px' fontWeight={400} color="#A3A3A3">
          Parking fee ({nights} Nights x €{parkingFee})
        </Text>
        <Text fontSize='14px' fontWeight={400} color="#A3A3A3">
          €{nights * parkingFee}
        </Text>
      </Flex>
      <Flex justifyContent='space-between' marginBottom={5}>
        <Text fontSize='18px' fontWeight={700} color="#1F1E1E">
          Total (€)
        </Text>
        <Text fontSize='18px' fontWeight={700} color="#1F1E1E">
          €{nights * parkingFee + nights * price + platformFee + housekeepingFee}
        </Text>
      </Flex>
      <Button label="Next" onClick={() => history.push(url)} colorScheme='blue' />
    </Flex>
  );
};

export { BookDetailsTile };
